export const modules = {
  "agrostream": "Агрострим",
  "admin": "Админ",
  "agrofact": "Агрофакт",
  "agroinfo": "Агроинфо",
  "agromap": "Агромап",
  "agroplan": "Агроплан",
  "agrostock": "Агросток",
  "grainbalance": "Баланс зерна",
  "biagro": "BI Агро",
}
